import { createApp } from 'vue';
import VueGtag from 'vue-gtag';
import App from './App.vue';
// import './registerServiceWorker';
import axios from './plugins/axios';
import router from './router';
import store from './store';

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store);
app.use(router);
app.use(
  VueGtag,
  {
    config: {
      id: 'G-M5KQYCVVPF',
    },
  },
  router,
);
app.mount('#app');
